import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    disabledText: String,
    confirmMessage: String
  };

  disable(event) {
    const button = event.currentTarget;

    // Prevent multiple clicks
    if (button.disabled) {
      event.preventDefault();
      event.stopPropagation();
      return false;
    }

    if (this.hasConfirmMessageValue) {
      if (!window.confirm(this.confirmMessageValue)) {
        event.preventDefault();
        return false;
      }
    }

    // Prevent the click's automatic form submission so the button can be
    // disabled before the form submits. This closes the race between
    // window.confirm() returning and requestAnimationFrame firing, during
    // which a phantom click could trigger a second confirmation dialog.
    event.preventDefault();

    if (this.disabledTextValue) {
      button.textContent = this.disabledTextValue;
    }

    button.disabled = true;

    if (button.form) {
      button.form.requestSubmit();
    }
  }
}
